var map = {
	"./logo1.svg": 999,
	"./logo10.svg": 436,
	"./logo11.svg": 245,
	"./logo12.svg": 526,
	"./logo2.svg": 239,
	"./logo3.svg": 118,
	"./logo4.svg": 353,
	"./logo5.svg": 432,
	"./logo6.svg": 795,
	"./logo7.svg": 602,
	"./logo8.svg": 805,
	"./logo9.svg": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;